import { component } from 'picoapp'

export default component((node, ctx) => {
  //console.log("header mounted");
  const cartCount = node.querySelector('.js-cart-count')
  const logo = node.querySelector('.js-logo-container')
  const cartToggles = node.querySelectorAll('.js-cart-drawer-toggle')
  const menuToggles = node.querySelectorAll('.js-menu-drawer-toggle')

  for (let i = 0; i < cartToggles.length; i++) {
    cartToggles[i].addEventListener('click', e => {
      e.preventDefault()
      //console.log("cart toggle")
      ctx.emit('cart:toggle', state => {
        return {
          cartOpen: !state.cartOpen
        }
      })
    })
  }

  ctx.on('cart:updated', state => {
    cartCount.innerHTML = state.cart.item_count
  })

  ctx.on('curtain:closed', state => {
    logo.classList.add('is-active')
    setTimeout(() => {
      logo.classList.add('is-visible')
    }, 50)
  })

  cartCount.innerHTML = ctx.getState().cart.item_count


  for (let i = 0; i < menuToggles.length; i++) {
    menuToggles[i].addEventListener('click', e => {
      e.preventDefault()

      ctx.emit('menu:toggle', state => {
        return {
          menuOpen: !state.menuOpen
        }
      })
    })
  }

})
